import api from '../api'
export default {
  namespaced: true,
  state: {
    produceTypeList: [],
    produceTypeDetail: ''
  },
  mutations: {
    GET_PRODUCETYPE_LIST (state, data) {
      data.forEach(item => {
        item.typeId = item.typeId + ''
      })
      state.produceTypeList = data
    },
    GET_PRODUCETYPE_DETAIL (state, data) {
      state.produceTypeDetail = data
    }
  },
  actions: {
    GET_PRODUCETYPE_LIST ({ commit, dispatch }, params) {
      return api.produceTypeList({
        params: params
      }).then((res) => {
        commit('GET_PRODUCETYPE_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    GET_PRODUCETYPE_DETAIL ({ commit, dispatch }, config) {
      return api.produceTypeDetail(config).then((res) => {
        commit('GET_PRODUCETYPE_DETAIL', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_PRODUCETYPE ({ commit, dispatch }, params) {
      return api.deleteProduceType({
        params: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    ADD_PRODUCETYPE ({ commit, dispatch }, config) {
      return api.addProduceType(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_PRODUCETYPE ({ commit, dispatch }, config) {
      return api.updateProduceType(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/produceTypeManage/store/index.js